// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3_dbm","footer":"ModalCreateQualiphyProcedure_footer__3-cjB","additionData":"ModalCreateQualiphyProcedure_additionData__3OjYG"};